// Necessite <script src="https://www.shape3d.com/js/jquery-1.7.min.js"></script>
// Courbes
function Shape(pointsbez) {
    this.closed = true;
    this.lineWidth = 1;
    this.lineColor = null;
    this.backgroundColor = null;
    var backgroundImage = null;
    var backgroundImageWidth = 0;
    var backgroundImageHeight = 0;
    var backgroundXOffset = 0;
    var backgroundyOffset = 0;
    var mirrorImage = false;

    this.clip = false;
    this.stopClip = false;
    
    this.symmetric = false;
    this.inversesym = false;
    this.symAxisX = 0;

    this.orthoShift = 0;
    this.orthoShift2 = 0;
    this.hShift = 0;
    this.widthFactShift = 1;
    this.widthFactShift2 = 1;

    this.openContourTail = false;

    this.colorGradient = null;
    this.inwardGradient = false;
    this.outwardGradient = false;
    this.forwardGradient = false;
    this.backwardGradient = false;
    this.yMin = 0;
    this.yMax = 0;

    var points = pointsbez; // Array de Vecteurs

    this.setBackgroundImage = function (img, width, height, dx, dy, mirror) {
        backgroundImage = img;
        backgroundImageWidth = width;
        backgroundImageHeight = height;
        backgroundXOffset = dx;
        backgroundYOffset = dy;
        mirrorImage = mirror;
    }

    this.draw = function (context) {
        if (this.stopClip)
            context.restore();
        if (this.clip)
            context.save();
        
        context.beginPath();

        this.trace(context);

        if (this.closed)
            context.closePath();

        if (backgroundImage != null) {
            var tempCanvas = document.createElement('canvas');
            var tempContext = tempCanvas.getContext('2d');
            tempCanvas.width = backgroundImageWidth + backgroundXOffset;
            tempCanvas.height = backgroundImageHeight + backgroundYOffset;
            tempContext.translate(backgroundXOffset, backgroundYOffset);

            if (mirrorImage)// flip context horizontally
            {
                tempContext.scale(-1, 1);
                tempContext.drawImage(backgroundImage, 0, 0, backgroundImageWidth * -1, backgroundImageHeight);
            }
            else
                tempContext.drawImage(backgroundImage, 0, 0, backgroundImageWidth, backgroundImageHeight);

            context.fillStyle = context.createPattern(tempCanvas, "no-repeat");
            context.fill();
        }
        if (this.colorGradient != null && (this.forwardGradient || this.backwardGradient)) {
            var endcol = "rgba(255, 255, 255, 0)";
            var endcol2 = null;
            if (this.backgroundColor != null) {
                endcol = this.backgroundColor;
            }
            else {
                var n = this.colorGradient.indexOf("rgba(");
                if (n == 0) {
                    n = this.colorGradient.lastIndexOf(",");
                    endcol = this.colorGradient.substring(0, n) + ", 0)";
                    endcol2 = this.colorGradient.substring(0, n) + ", 0.1)";
                }
            }
            if (this.yMax <= this.yMin) {
                this.yMax = this.yMin = points[0].y;
                for (var i = 1; i < points.length; i++) {
                    if (points[i].y > this.yMax)
                        this.yMax = points[i].y;
                    else if (points[i].y < this.yMin)
                        this.yMin = points[i].y;
                }
            }
            var grd = context.createLinearGradient(0, this.yMin, 0, this.yMax);
            if (this.forwardGradient && this.backwardGradient) {
                if (endcol2 == null) {
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(0.5, this.colorGradient);
                    grd.addColorStop(1, endcol);
                }
                else { // Pour que ca ressemble plus au dégradé Shape3d
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(0.08, endcol2);
                    grd.addColorStop(0.5, this.colorGradient);
                    grd.addColorStop(0.92, endcol2);
                    grd.addColorStop(1, endcol);
                }
            }
            else if (this.forwardGradient) {
                if (endcol2 == null) {
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(1, this.colorGradient);
                }
                else { // Pour que ca ressemble plus au dégradé Shape3d
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(0.25, endcol2);
                    grd.addColorStop(1, this.colorGradient);
                }
            }
            else if (this.backwardGradient) {
                if (endcol2 == null) {
                    grd.addColorStop(0, this.colorGradient);
                    grd.addColorStop(1, endcol);
                }
                else { // Pour que ca ressemble plus au dégradé Shape3d
                    grd.addColorStop(0, this.colorGradient);
                    grd.addColorStop(0.75, endcol2);
                    grd.addColorStop(1, endcol);
                }

            }
            context.fillStyle = grd;
            context.fill();
        }
        else if (this.backgroundColor != null) {
            context.fillStyle = this.backgroundColor;
            context.fill();
        }

        if (this.lineColor != null) {
            context.lineWidth = this.lineWidth;
            context.strokeStyle = this.lineColor;
            context.stroke();
        }

        if (this.clip)
            context.clip();

        if (this.colorGradient != null && ((this.orthoShift2 > this.orthoShift) || (this.widthFactShift2 < this.widthFactShift)) && (this.inwardGradient || this.outwardGradient))
        {
            if (!this.clip && context.constructor.name == "CanvasRenderingContext2D") // Clip pour que le degradé reste à l'interrieure 
            { // PAS SI Canvas2Svg car ça déconne
                context.save();
                context.clip();
            }

            var gradWidth = 1;
            if (this.orthoShift2 > this.orthoShift) {
                gradWidth = this.orthoShift2 - this.orthoShift;
                var pts = points;
                if (this.inwardGradient && this.outwardGradient) {
                    pts = this.DecallePolyArray((this.orthoShift2 + this.orthoShift) * 0.5);
                }
                else {
                    gradWidth *= 2;
                    if (this.inwardGradient && (this.orthoShift != 0 || this.hShift != 0))
                        pts = this.DecallePolyArray(this.orthoShift);
                    else if (this.outwardGradient && (this.orthoShift2 != 0 || this.hShift != 0))
                        pts = this.DecallePolyArray(this.orthoShift2);
                }

            }
            else if (this.widthFactShift2 < this.widthFactShift) {
                var nbp = points.length;
                var ptsxmin = points[0].x; // points en x inf à x centre
                var ptsxmax = points[0].x; // points en x inf à x centre
                for (var i = 0; i < nbp; i++) {
                    if (points[i].x < ptsxmin)
                        ptsxmin = points[i].x;
                    else if (points[i].x > ptsxmax)
                        ptsxmax = points[i].x;
                }
                gradWidth = (ptsxmax - ptsxmin) * (this.widthFactShift - this.widthFactShift2);
                var pts = points;
                if (this.inwardGradient && this.outwardGradient) {
                    pts = this.ResizeWidthFact((this.widthFactShift2 + this.widthFactShift) * 0.5);
                }
                else {
                    gradWidth *= 2;
                    if (this.inwardGradient && (this.widthFactShift != 1 || this.hShift != 0))
                        pts = this.ResizeWidthFact(this.widthFactShift);
                    else if (this.outwardGradient && (this.widthFactShift2 != 1 || this.hShift != 0))
                        pts = this.ResizeWidthFact(this.widthFactShift2);
                }
                
            }

            context.strokeStyle = this.colorGradient;
            var lineJoinPrev = context.lineJoin;
            context.lineJoin = 'round';
            var globalAlphaPrev = context.globalAlpha;
            context.globalAlpha = 0.01; // Min value

            context.lineWidth = gradWidth;
            for (var j = 1; j < 100; j++) {
                context.beginPath();
                context.moveTo(pts[0].x, pts[0].y);
                this.traceArray(context, pts, false);
                if (this.closed)
                    context.closePath();
                context.stroke();

                context.lineWidth = gradWidth * Math.exp(-j * 0.1);
                context.globalAlpha += 0.01;
                if (context.lineWidth < 1)
                    break;
            }

            context.globalAlpha = globalAlphaPrev;
            context.lineJoin = lineJoinPrev;

            if (!this.clip && context.constructor.name == "CanvasRenderingContext2D") // Clip pour que le degradé reste à l'interrieure 
            { // PAS SI Canvas2Svg car ça déconne
                context.restore();

                // Et on restroke sans clip pour ligne nete
                context.lineWidth = 2;
                context.strokeStyle = this.colorGradient;
                if (this.inwardGradient && !this.outwardGradient) {
                    context.beginPath();
                    context.moveTo(pts[0].x, pts[0].y);
                    this.traceArray(context, pts, false);
                    if (this.closed)
                        context.closePath();
                    context.stroke();
                }
                else if (!this.inwardGradient && this.outwardGradient) {
                    context.beginPath();
                    context.moveTo(pts[0].x, pts[0].y);
                    this.traceArray(context, pts, false);
                    if (this.closed)
                        context.closePath();
                    context.stroke();
                }
            }
        }
    }

    this.trace = function (context) {
        if (this.orthoShift2 == 0 && this.widthFactShift2 == 1) { // Un seul tracé
            var pts = points;
            if (this.orthoShift != 0)
                pts = this.DecallePolyArray(this.orthoShift);
            else if (this.widthFactShift != 1)
                pts = this.ResizeWidthFact(this.widthFactShift);

            var p0 = new Vector(pts[0].x, pts[0].y);
            if ((this.symmetric || this.inversesym || this.symAxisX != 0) && Math.abs(pts[0].x - this.symAxisX) > 0.01) {
                p0.x = this.symAxisX;
                context.moveTo(p0.x, p0.y);
                if (this.inversesym)
                    context.lineTo(this.symAxisX * 2 - pts[0].x, pts[0].y);
                else
                    context.lineTo(pts[0].x, pts[0].y);
            }
            else {
                if (this.inversesym)
                    context.moveTo(this.symAxisX * 2 - pts[0].x, pts[0].y);
                else
                    context.moveTo(pts[0].x, pts[0].y);
            }

            this.traceArray(context, pts, false);

            if (this.symmetric)
                context.lineTo(p0.x, p0.y);
            else if ((this.inversesym || this.symAxisX != 0) && Math.abs(pts[pts.length - 1].x - this.symAxisX) > 0.01) {
                p0 = new Vector(pts[pts.length - 1].x, pts[pts.length - 1].y);
                p0.x = this.symAxisX;
                context.lineTo(p0.x, p0.y);
            }
        }
        else { // 2 tracés
            var pts = points;

            // Outline ext
            if (this.orthoShift != 0)
                pts = this.DecallePolyArray(this.orthoShift);
            else if (this.widthFactShift != 1)
                pts = this.ResizeWidthFact(this.widthFactShift);

            var p0 = new Vector(pts[0].x, pts[0].y);
            if ((this.symmetric || this.inversesym || this.symAxisX != 0) && Math.abs(pts[0].x - this.symAxisX) > 0.01) {
                p0.x = this.symAxisX;
                context.moveTo(p0.x, p0.y);
                if (this.inversesym)
                    context.lineTo(this.symAxisX * 2 - pts[0].x, pts[0].y);
                else
                    context.lineTo(pts[0].x, pts[0].y);
            }
            else {
                if (this.inversesym)
                    context.moveTo(this.symAxisX * 2 - pts[0].x, pts[0].y);
                else
                    context.moveTo(pts[0].x, pts[0].y);
            }

            this.traceArray(context, pts, false);

            if (this.symmetric) {
                context.lineTo(p0.x, p0.y);
            }
            else if ((this.inversesym || this.symAxisX != 0) && Math.abs(pts[pts.length - 1].x - this.symAxisX) > 0.01) {
                p0 = new Vector(pts[pts.length - 1].x, pts[pts.length - 1].y);
                p0.x = this.symAxisX;
                context.lineTo(p0.x, p0.y);
            }

            // Outline int
            var pts2;
            if (this.orthoShift2 != 0)
                pts2 = this.DecallePolyArray(this.orthoShift2);
            else if (this.widthFactShift2 != 1)
                pts2 = this.ResizeWidthFact(this.widthFactShift2);

            if (this.symmetric) {
                var p1 = new Vector(pts2[0].x, pts2[0].y);
                if (Math.abs(pts2[0].x - this.symAxisX) > 0.01) {
                    p1.x = this.symAxisX;
                    context.lineTo(p1.x, p1.y);
                }

                context.lineTo(this.symAxisX * 2 - pts2[0].x, pts2[0].y);
                this.traceArray(context, pts2, true);

                if (Math.abs(pts2[0].x - this.symAxisX) > 0.01)
                    context.lineTo(p1.x, p1.y);
                //context.lineTo(p0.x, p1.y);
            }
            else {
                var p1 = new Vector(pts2[pts2.length - 1].x, pts2[pts2.length - 1].y);
                if ((this.inversesym || this.symAxisX != 0) && Math.abs(pts2[pts2.length - 1].x - this.symAxisX) > 0.01) {
                    p1.x = this.symAxisX;
                    context.lineTo(p1.x, p1.y);
                }

                if (this.inversesym)
                    context.lineTo(this.symAxisX * 2 - pts2[pts2.length - 1].x, pts2[pts2.length - 1].y);
                else
                    context.lineTo(pts2[pts2.length - 1].x, pts2[pts2.length - 1].y);

                this.traceArray(context, pts2, true);

                if ((this.inversesym || this.symAxisX != 0) && Math.abs(pts2[0].x -this.symAxisX) > 0.01) {
                    p1 = new Vector(pts2[0].x, pts2[0].y);
                    p1.x = this.symAxisX;
                    context.lineTo(p1.x, p1.y);
                }
            }
        }
    }
    this.traceArray = function (context, pts, sensinverse) {
        if ((sensinverse && !this.inversesym) || (!sensinverse && this.inversesym))
        {
            if (this.symmetric || this.inversesym) {
                var symAxisX2 = this.symAxisX * 2;
                for (var i = 1; i < pts.length; i++) {
                    context.bezierCurveTo(symAxisX2 - pts[i].x, pts[i].y, symAxisX2 - pts[i + 1].x, pts[i + 1].y, symAxisX2 - pts[i + 2].x, pts[i + 2].y);
                    i += 2;
                }
                context.lineTo(pts[pts.length - 1].x, pts[pts.length - 1].y);
            }

            if (this.symmetric || !this.inversesym) {
                for (var i = pts.length - 2; i > 0; i--) {
                    context.bezierCurveTo(pts[i].x, pts[i].y, pts[i - 1].x, pts[i - 1].y, pts[i - 2].x, pts[i - 2].y);
                    i -= 2;
                }
            }
        }
        else
        {
            if (this.symmetric || !this.inversesym) {
                for (var i = 1; i < pts.length; i++) {
                    context.bezierCurveTo(pts[i].x, pts[i].y, pts[i + 1].x, pts[i + 1].y, pts[i + 2].x, pts[i + 2].y);
                    i += 2;
                }
            }

            if (this.symmetric || this.inversesym) {
                var symAxisX2 = this.symAxisX * 2;
                context.lineTo(symAxisX2 - pts[pts.length - 1].x, pts[pts.length - 1].y);
                for (var i = pts.length - 2; i > 0; i--) {
                    context.bezierCurveTo(symAxisX2 - pts[i].x, pts[i].y, symAxisX2 - pts[i - 1].x, pts[i - 1].y, symAxisX2 - pts[i - 2].x, pts[i - 2].y);
                    i -= 2;
                }
            }
        }
    }
    this.DecallePolyArray = function (dec) {
        // 11/02/2015 Il ne faut pas qu'il y ai de tg nulle. Code inspiré de polygone::decal dans Shape3d
        if (this.symmetric) {
            return this.DecallePolyArray2(points, dec, this.symmetric, this.symAxisX);
        }
        else {
            var nbp = points.length;
            //alert(points[0].x + "; " + points[nbp - 1].x + "; " + this.symAxisX);

            if (points[0].y == points[nbp - 1].y && points[0].x < this.symAxisX && points[nbp - 1].x > this.symAxisX)
            { // Boucle avec axe symAxisX on coupe points en 2
                var nbp1 = 0;
                for (var i = 1; i < nbp; i++) {
                    if (points[i].x >= this.symAxisX)
                    {
                        nbp1 = i;
                        break;
                    }
                }
                if (nbp1 < nbp - 1) // && points[nbp1 - 1].x == points[nbp1 - 2].x && points[nbp1].x == points[nbp1 + 1].x)
                {
                    var pdec1 = new Array();
                    for (var i = 0; i < nbp1-1; i++) {
                        pdec1.push(new Vector(points[i].x, points[i].y));
                    }
                    var pdec2 = new Array();
                    for (var i = nbp - 1; i > nbp1; i--) {
                        pdec2.push(new Vector(2 * this.symAxisX - points[i].x, points[i].y));
                    }

                    //var teststr = "pdec1:";
                    //for (var i = 0; i < npdec1.length; i++) {
                    //    teststr += "(" + pdec1[i].x + ";" + pdec1[i].y + ")";
                    //}
                    //teststr += "pdec2:";
                    //for (var i = 0; i < npdec2.length; i++) {
                    //    teststr += "(" + pdec2[i].x + ";" + pdec2[i].y + ")";
                    //}
                    //alert(teststr);
                    
                    pdec1 = this.DecallePolyArray2(pdec1, dec, true, this.symAxisX);
                    pdec2 = this.DecallePolyArray2(pdec2, dec, true, this.symAxisX);

                    var pdec = new Array();
                    nbp1 = pdec1.length;
                    for (var i = 0; i < nbp1; i++) {
                        pdec.push(new Vector(pdec1[i].x, pdec1[i].y));
                    }
                    pdec.push(new Vector(pdec1[nbp1-1].x, pdec1[nbp1-1].y));
                    var nbp2 = pdec2.length;
                    pdec.push(new Vector(2 * this.symAxisX - pdec2[nbp2 - 1].x, pdec2[nbp2 - 1].y));
                    for (var i = nbp2-1; i >= 0; i--) {
                        pdec.push(new Vector(2 * this.symAxisX - pdec2[i].x, pdec2[i].y));
                    }
                    return pdec;
                }
                else
                {
                    return this.DecallePolyArray2(points, dec, this.symmetric, this.symAxisX);
                }
            }
            else
            {
                return this.DecallePolyArray2(points, dec, this.symmetric, this.symAxisX);
            }
        }
    }
    this.DecallePolyArray2 = function (pds, dec, sym, symaxisx) {
        // 07/01/2019 pour outline asym qu'on fait en 2 fois
        // pdec est un Array
        // dec un double
        // sym un bool
        // symaxisx un double
        var nbp = pds.length;
        var pdec = new Array();
        for (var i = 0; i < nbp; i++) {
            pdec.push(new Vector(pds[i].x, pds[i].y));
        }
        
        if (dec != 0) {
            var p0 = new Vector(0, 0);
            var p1 = new Vector(0, 0);
            var p2 = new Vector(0, 0);
            var pi = new Vector(0, 0);
            var s1 = new Segment(p0, p0);
            var s2 = new Segment(p0, p0);
            var seg1disp = false;
            var seg2disp = false;
            var segdebdisp = false;
            var segfindisp = false;
            var dj = 0;
            var y = 0;

            // Premier segment
            if (sym && (pds[0].x - symaxisx) > -0.01) // point tail sur axe
            {
                s2 = new Segment(pds[0], pds[1]);
                if (s2.decalleVect(dec)) {
                    pi = s2.f_de_x(symaxisx);
                    if (pi.x == symaxisx && pi.y <= pds[0].y && pi.y >= pds[nbp - 1].y)
                        s2.setp0(pi);
                }
                pdec[0].copy(s2.p0);
            }
            else {
                s1 = new Segment(new Vector(symaxisx, pds[0].y - dec), new Vector(pds[0].x, pds[0].y - dec));
                s2 = new Segment(pds[0], pds[1]);
                if (s2.decalleVect(dec)) {
                    if (!s1.intersection(s2, pi))
                        pi.copy(pds[0]);
                    pdec[0].copy(pi);

                    lbda = s1.lambda(pi);
                    lbda2 = s2.lambda(pi);
                    if (lbda > -0.001) // on met le bout du segment à l'intersection
                    {
                        s1.setp1(pi);
                        seg1disp = false;
                    }
                    else // segment disparait
                        seg1disp = true;
                    if (lbda2 < 1.001) // on met le bout du segment à l'intersection
                    {
                        s2.setp0(pi);
                        seg2disp = false;
                    }
                    else // segment disparait
                        seg2disp = true;

                    if (seg2disp) { // On conserve segment prev et avance segment
                        s2.copy(s1);
                        dj++;
                    }
                }
                else {
                    s2.copy(s1);
                    dj++;
                }
            }

            // Arcs
            for (var i = 1; i < nbp - 1; i++) {
                s1.copy(s2);
                s2 = new Segment(pds[i], pds[i + 1]);
                if (s2.decalleVect(dec)) {
                    if (!s1.intersection(s2, pi)) {
                        pi.copy(s1.p1);
                    }
                    lbda = s1.lambda(pi);
                    lbda2 = s2.lambda(pi);
                    if (lbda > -0.001) // on met le bout du segment à l'intersection
                    {
                        //s1.setp1(pi);
                        seg1disp = false;
                    }
                    else {
                        if (i - 1 - dj > 0)// segment disparait sauf si on est revenu au debut
                            seg1disp = true;
                        else {
                            seg1disp = false;
                            segdebdisp = true;
                        }
                    }
                    if (lbda2 < 1.001) // on met le bout du segment à l'intersection
                    {
                        //s2.setp0(pi);
                        seg2disp = false;
                    }
                    else // segment disparait
                    {
                        if (i < nbp - 2) // 19/09/2014
                            seg2disp = true;
                        else {
                            seg2disp = false;
                            segfindisp = true;
                        }
                    }
                    if (seg1disp && seg2disp) { // On recule segment prev et avance segment
                        dj++;
                        s2 = new Segment(pds[i - 1 - dj], pds[i - dj]);
                        while (!s2.decalleVect(dec) && i - 1 - dj >= 0)
                        {
                            dj++;
                            s2 = new Segment(pds[i - 1 - dj], pds[i - dj]);
                        }
                        if (i - 1 - dj == 0)
                            s2.setp0(pdec[0]);
                        dj++;
                    }
                    else if (seg1disp) { // On recule segment prev et conserve segment
                        dj++;
                        s2 = new Segment(pds[i - 1 - dj], pds[i - dj]);
                        while (!s2.decalleVect(dec) && i - 1 - dj >= 0) {
                            dj++;
                            s2 = new Segment(pds[i - 1 - dj], pds[i - dj]);
                            //i--;
                        }
                        if (i - 1 - dj == 0)
                            s2.setp0(pdec[0]);
                        i--;
                    }
                    else if (seg2disp) { // On conserve segment prev et avance segment
                        s2.copy(s1);
                        dj++;
                    }
                    else {
                        //s1.setp1(pi);
                        s2.setp0(pi);
                        for (var j = 0; j <= dj; j++)
                            pdec[i - j].copy(pi);
                        dj = 0;
                    }
                }
                else // segment null on saute 21/08/2019
                {
                    s2.copy(s1);
                    dj++;
                }
            }

            // Nose
            s1.copy(s2);
            if (sym && (pds[nbp - 1].x - symaxisx) > -0.01) // point tail sur axe
            {
                pi = s1.f_de_x(this.symAxisX);
                if (pi.x == this.symAxisX)
                    s1.setp0(pi);
                pdec[nbp - 1].copy(s1.p1);
            }
            else {
                s1 = new Segment(new Vector(pds[nbp - 1].x, pds[nbp - 1].y + dec), new Vector(symaxisx, pds[nbp - 1].y + dec));
                if (!s1.intersection(s2, pi))
                    pi.copy(s1.p1);
                for (var j = 0; j <= dj; j++)
                    pdec[nbp - 1 - j].copy(pi);
            }


            // Gestion des segments des extr qui disparaissent 13/02/2015
            if (segdebdisp) {
                if (sym && (pdec[0].x - symaxisx) < -0.01) // 13/02/2015
                { // On prolonge
                    s1 = new Segment(pdec[0], pdec[1]);
                    pi = s1.f_de_x(symaxisx);
                    if (pi.x == symaxisx && pi.y <= pds[0].y && pi.y >= pds[nbp - 1].y) {
                        pdec[0] = pi;
                    }
                    else
                        pdec[0] = pdec[1];
                }
                else
                    pdec[0] = pdec[1];
            }
            if (segfindisp) {
                if (sym && (pdec[nbp - 1].x - symaxisx) < -0.01) // 13/02/2015
                { // On prolonge
                    s2 = new Segment(pdec[nbp - 2], pdec[nbp - 1]);
                    pi = s2.f_de_x(symaxisx);
                    if (pi.x == symaxisx && pi.y <= pds[0].y && pi.y >= pds[nbp - 1].y)
                        pdec[nbp - 1] = pi;
                    else
                        pdec[nbp - 1] = pdec[nbp - 2];
                }
                else
                    pdec[nbp - 1] = pdec[nbp - 2];
            }

            // Detecte les points en x > this.symAxisX
            if (sym) {
                // On part du tail
                for (var i = 1; i < nbp - 1; i++) {
                    if (pdec[i].x > symaxisx) {
                        if (pdec[i + 1].x <= symaxisx) {
                            s1 = new Segment(pdec[i], pdec[i + 1]);
                            pi = s1.f_de_x(symaxisx);
                            if (pi.x == symaxisx) {
                                for (var j = 0; j <= i; j++)
                                    pdec[j].copy(pi);
                            }
                        }
                    }
                    else
                        break;
                }
                // On part du nose
                for (var i = nbp - 1; i > 0; i--) {
                    if (pdec[i].x > symaxisx) {
                        if (pdec[i - 1].x <= symaxisx) {
                            s1 = new Segment(pdec[i - 1], pdec[i]);
                            pi = s1.f_de_x(symaxisx);
                            if (pi.x == symaxisx) {
                                for (var j = i; j < nbp; j++)
                                    pdec[j].copy(pi);
                            }
                        }
                    }
                    else
                        break;
                }
            }
        }

        // Decallage pour colorbands
        if (this.hShift != 0) {
            for (var i = 0; i < nbp; i++) {
                pdec[i].y -= this.hShift;
            }
        }

        // Ouverture tail retire swallow et prolonge
        if (this.openContourTail) {
            var ymax = pdec[0].y;
            var iymax = 0;
            // Commence par retirer swallow en detectant la pointe 
            for (var i = 1; i < nbp; i++) {
                if (pdec[i].y >= ymax) {
                    ymax = pdec[i].y;
                    iymax = i;
                }
            }
            
            // On ouvre pas si round tail
            if (((iymax != 1 && pdec[iymax].x < symaxisx) || (iymax == 1 && pdec[iymax - 1].x < symaxisx)) && iymax < nbp - 1) { // iymax == 1 est la tg 
                // Cherche ymax0
                var ymax0 = pds[0].y;
                // Commence par retirer swallow ou 
                for (var i = 1; i < nbp; i++) {
                    if (pds[i].y >= ymax0)
                        ymax0 = pds[i].y;
                }
                // Puis on prolonge jusqu'à pds[iymax].y
                if (ymax < ymax0 && iymax < nbp - 1) {
                    var di = 1;
                    while (iymax + di < nbp - 1 && pdec[iymax].y - pdec[iymax + di].y <= 1)
                        di++;
                    var s0 = new Segment(pdec[iymax], pdec[iymax + di]);
                    var s1 = new Segment(new Vector(0, ymax0), new Vector(1, ymax0));
                    var pi = new Vector(0, 0);
                    if (s0.intersection(s1, pi) && pi.x < symaxisx) {
                        for (var i = 0; i <= iymax; i++) {
                            pdec[i].copy(pi);
                        }
                    }
                }
            }
        }

        return pdec;
    }
    this.ResizeWidthFact = function (fact) {
        var nbp = points.length;
        var pdec = new Array();
        for (var i = 0; i < nbp; i++) {
            pdec.push(new Vector((points[i].x - this.symAxisX) * fact + this.symAxisX, points[i].y - this.hShift));
        }

        return pdec;
    }
}
// Images
function Layer(img, centerx, centery, width, height, angle) {
    this.img = img;
    this.imgLoaded = false;
    this.centerX = centerx;
    this.centerY = centery;
    this.width = width; // img.naturalHeight;
    this.height = height; // img.naturalHeight;

    this.angle = angle; // 0;

    this.mirror = false;

    this.allowDrag = true;
    this.allowRotation = true;
    this.allowResize = true;

    this.minX = 0;
    this.maxX = 0;
    this.minY = 0;
    this.maxY = 0;

    this.backgroundColor = null;//'blue';

    this.iShape = -1; // pour être tracé juste après un shape plutot qu'à la fin

    this.cooTextId = "";
    this.requireSavingCoordinates = false;
    this.title = "";

    this.canvas = document.createElement('canvas');
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.context = this.canvas.getContext('2d');
    this.context.save();
    this.context.translate(this.width / 2, this.height / 2);

    this.opacity = 1;
    this.visible = true;
    this.shadow = false;
    this.compositeOperation = "source-over";

    this.colorGradient = null;
    this.forwardGradient = false;
    this.backwardGradient = false;

    this.isVisible = function () {
        return this.visible;
    }
    this.toggleVisible = function () {
        this.visible = !this.visible;
    }

    this.hasShadow = function () {
        return this.shadow;
    }
    this.toggleShadow = function () {
        this.shadow = !this.shadow;
    }
    this.setShadow = function (shadow) {
        this.shadow = shadow;
    }

    this.getOpacity = function () {
        return this.opacity;
    }
    this.setOpacity = function (opacity) {
        this.opacity = opacity;
    }
    this.getImage = function () {
        return this.img;
    }

    this.setCompositeOperation = function (compositeOperation) {
        this.compositeOperation = compositeOperation;
    }
    this.getCompositeOperation = function () {
        return this.compositeOperation;
    }

    this.redraw = function (mouseDown) {
        this.draw(this.context, mouseDown);
    }
    this.draw = function (ctx, mouseDown) {
        var startX = -this.width / 2;
        var startY = -this.height / 2;

        if (this.colorGradient != null && (this.forwardGradient || this.backwardGradient))
        {
            ctx.clearRect(startX, startY, this.width, this.height);
            var endcol = "rgba(255, 255, 255, 0)";
            var endcol2 = null;
            if (this.backgroundColor != null) {
                endcol = this.backgroundColor;
            }
            else {
                var n = this.colorGradient.indexOf("rgba(");
                if (n == 0) {
                    n = this.colorGradient.lastIndexOf(",");
                    endcol = this.colorGradient.substring(0, n) + ", 0)";
                    endcol2 = this.colorGradient.substring(0, n) + ", 0.1)";
                }
            }

            var grd = ctx.createLinearGradient(0, startY, 0, startY + this.height);
            if (this.forwardGradient && this.backwardGradient)
            {
                if (endcol2 == null) {
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(0.5, this.colorGradient);
                    grd.addColorStop(1, endcol);
                }
                else { // Pour que ca ressemble plus au dégradé Shape3d
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(0.08, endcol2);
                    grd.addColorStop(0.5, this.colorGradient);
                    grd.addColorStop(0.92, endcol2);
                    grd.addColorStop(1, endcol);
                }
            }
            else if (this.forwardGradient) {
                if (endcol2 == null) {
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(1, this.colorGradient);
                }
                else { // Pour que ca ressemble plus au dégradé Shape3d
                    grd.addColorStop(0, endcol);
                    grd.addColorStop(0.25, endcol2);
                    grd.addColorStop(1, this.colorGradient);
                }
            }
            else if (this.backwardGradient) {
                if (endcol2 == null) {
                    grd.addColorStop(0, this.colorGradient);
                    grd.addColorStop(1, endcol);
                }
                else { // Pour que ca ressemble plus au dégradé Shape3d
                    grd.addColorStop(0, this.colorGradient);
                    grd.addColorStop(0.75, endcol2);
                    grd.addColorStop(1, endcol);
                }
                
            }
            ctx.fillStyle = grd;
            ctx.fillRect(startX, startY, this.width, this.height);
        }
        else if (this.backgroundColor != null && this.backgroundColor != '')
        {
            ctx.fillStyle = this.backgroundColor;
            ctx.fillRect(startX, startY, this.width, this.height);
        }
        else if (ctx.constructor.name == "CanvasRenderingContext2D")
            ctx.clearRect(startX, startY, this.width, this.height);

        if (this.img != null) {
            var ratiox = 1.0;
            var ratioy = 1.0;
            if (this.img.width > 0)
                ratiox = this.width / this.img.width;
            if (this.img.height > 0)
                ratioy = this.height / this.img.height;


            // Ancien système désactivé le 13/09/2019
            //if (!mouseDown && ratiox < 0.9 && ratioy < 0.9 && this.img.width < 5000 && this.img.height < 5000) { // Pas si mouseDown ou image trop grosse car ralenti 06/11/2018
            //    var can2 = document.createElement('canvas');
            //    var ctx2 = can2.getContext('2d');
            //    var rx, ry;
            //    var w, h, w0, h0;

            //    if (ratiox < 0.5 && ratioy < 0.5) {
            //        w = Math.round(this.img.width * 0.5);
            //        h = Math.round(this.img.height * 0.5);
            //        can2.width = w;
            //        can2.height = h;
            //        ctx2.drawImage(img, 0, 0, w, h);

            //        if (ratiox < 0.25 && ratioy < 0.25) { // 2 itérations max sinon ça devient flou
            //            w = Math.round(w * 0.5);
            //            h = Math.round(h * 0.5);
            //            var can3 = document.createElement('canvas');
            //            can3.width = w;
            //            can3.height = h;
            //            var ctx3 = can3.getContext('2d');
            //            ctx3.drawImage(can2, 0, 0, w, h);

            //            ctx2.clearRect(0, 0, w, h);
            //            ctx2.drawImage(can3, 0, 0, w, h);
            //        }
            //    }
            //    else {
            //        w = this.img.width;
            //        h = this.img.height;
            //        can2.width = w;
            //        can2.height = h;
            //        ctx2.drawImage(img, 0, 0);
            //    }

            //    resample_hermite(can2, w, h, this.width, this.height);

            //    if (this.mirror)// flip context horizontally
            //    {
            //        this.context.save();
            //        this.context.scale(-1, 1);
            //    }

            //    this.context.drawImage(can2, startX, startY, this.width, this.height);

            //    if (this.mirror)// flip context horizontally
            //        this.context.restore();
            //}
            //else
            //{
            if (this.mirror)// flip context horizontally
            {
                ctx.save();
                ctx.scale(-1, 1);
            }

            if (ctx.constructor.name == "CanvasRenderingContext2D") {
                // grid_2I_12F.png a été créé à partir de grid_2I_12F.svg avec https://cloudconvert.com/svg-to-png et en spécifiant 7200 pour la taille (dans les options de conversion)
                var forceReduce = (this.img.src.endsWith("910/Images/Grids/grid_2I_12F.png") && (isFirefox() || isEdge())); // Avec Firefox et Edge la grille ne s'affiche plus sans la technique de réduction à partir d'une certaine taille de Print Sheet
                var stepsWidth = (this.img.width < 5000 || forceReduce ? Math.ceil(Math.log(this.img.width / this.width) / Math.log(2)) : 1);
                var stepsHeight = (this.img.height < 5000 || forceReduce ? Math.ceil(Math.log(this.img.height / this.height) / Math.log(2)) : 1);
                // Modif Clem le 12/09/2019 : à partir de https://stackoverflow.com/questions/17861447/html5-canvas-drawimage-how-to-apply-antialiasing
                if (!mouseDown && (stepsWidth > 1 || stepsHeight > 1)) {
                    //console.log("Reduce");
                    var ocPrec = this.img;
                    for (var i = 1; i < Math.max(stepsWidth, stepsHeight); i++) { // Pas vu de différence en minorant à 3, c'est plutôt resample_hermite3 qui rame
                        var oc = document.createElement('canvas');
                        var octx = oc.getContext('2d');
                        oc.width = Math.max(1, ocPrec.width * 0.5);
                        oc.height = Math.max(1, ocPrec.height * 0.5);
                        if (this.mirror && i == 1) {
                            octx.translate(oc.width, 0);
                            octx.scale(-1, 1);
                        }
                        octx.drawImage(ocPrec, 0, 0, oc.width, oc.height); // Ici ne pas désactiver imageSmoothingEnabled : vu sur Board=542
                        ocPrec = oc;
                    }
                    resample_hermite3(ctx, ocPrec, this.width, this.height);
                }
                else {
                    //console.log("Normal");
                    ctx.imageSmoothingEnabled = true; // Déjà activé par défaut dans Chrome
                    ctx.imageSmoothingQuality = "high"; // imageSmoothingQuality marche uniquement avec Chrome
                    ctx.drawImage(this.img, startX, startY, this.width, this.height);
                }
            }
            else { // Pour Export Svg
                ctx.drawImage(this.img, startX, startY, this.width, this.height);
            }

            if (this.mirror)// flip context horizontally
                ctx.restore();
            //}
        }
    }

    this.getCanvas = function (mouseDown) {
        this.redraw(mouseDown);
        return this.canvas;
    }

    this.intersect = function (x, y) {
        return this.getSquare().intersect(new Vector(x, y));
    }

    this.getSquare = function () {
        var offsetX = this.centerX - (this.width / 2);
        var offsetY = this.centerY - (this.height / 2);
        var square = new Square(
    new Vector(offsetX, offsetY),
    new Vector(offsetX + this.width, offsetY),
    new Vector(offsetX + this.width, offsetY + this.height),
    new Vector(offsetX, offsetY + this.height));
                
        square.rotate(this.angle);

        return square;
    }

    this.scale = function (width, height) {
        this.context.restore();

        this.width = width;
        this.height = height;
        this.canvas.width = width;
        this.canvas.height = height;

        this.context.translate(this.width / 2, this.height / 2);

        this.redraw();
    }

    this.getCoordinates = function () {
        var info = "title=" + this.title + "&src=" + this.img.src
            + "&centerx=" + (Math.round(this.centerX*1000)/1000).toString()
            + "&centery=" + (Math.round(this.centerY*1000)/1000).toString()
            + "&width=" + (Math.round(this.width*1000)/1000).toString()
            + "&height=" + (Math.round(this.height*1000)/1000).toString()
            + "&angle=" + (Math.round(this.angle * 1000)/1000).toString()
        
        return info;
    }
}

function Stage(canvasId) {
    var NONE = 0, MOVING = 1, SCALING = 2, ROTATING = 3;

    var mouseDown = false;
    var touch = false;
    var mousePrevX = 0;
    var mousePrevY = 0;

    var selectedLayer = null;
    var layerState = NONE;

    var backgroundColor = null;
    var backgroundImage = null;

    var scaleImg = new Image();
    //var rotateImg = new Image();
    var rotateImgLrg = new Image();
    scaleImg.src = "https://www.shape3d.com/Images/resize.png";
    //rotateImg.src = "https://www.shape3d.com/Images/rotate.png";
    rotateImgLrg.src = "https://www.shape3d.com/Images/rotate-large.png";

    var canvas = jQuery(canvasId)[0]; // $ est une syntax JQuery qui demande jquery-1.7.min.js !!!

    var context = canvas.getContext('2d');

    // Oversize pour meilleur rendu 07/02/2017 https://www.html5rocks.com/en/tutorials/canvas/hidpi/
    var devicePixelRatio = (typeof queryString != "undefined" && queryString["FullScaleDpi"] ? 1 : window.devicePixelRatio || 1);
    var backingStoreRatio = context.webkitBackingStorePixelRatio ||
                            context.mozBackingStorePixelRatio ||
                            context.msBackingStorePixelRatio ||
                            context.oBackingStorePixelRatio ||
                            context.backingStorePixelRatio || 1;

    var ratio = devicePixelRatio / backingStoreRatio;
    var oldWidth = canvas.width;
    var oldHeight = canvas.height;
    canvas.width = oldWidth * ratio;
    canvas.height = oldHeight * ratio;
    canvas.style.width = oldWidth + 'px';
    canvas.style.height = oldHeight + 'px';
    context.scale(ratio, ratio);

    // Images
    var layers = new Array();
    // Courbes
    var shapes = new Array();

    var readyToSaveImg = false;

    canvas.addEventListener('mousemove', mouseMoveEvent, false);
    canvas.addEventListener('mousedown', mouseDownEvent, false);
    canvas.addEventListener('mouseup', mouseUpEvent, false);
    canvas.addEventListener('mouseout', mouseOutEvent, false);
    canvas.addEventListener('mouseleave', mouseOutEvent, false);
    canvas.addEventListener('touchmove', touchMoveEvent, false);
    canvas.addEventListener('touchstart', touchStartEvent, false);
    canvas.addEventListener('touchend', touchEndEvent, false);

    this.addLayer = function (img, centerx, centery, width, height, angle, redraw) {
        var layer = new Layer(img, centerx, centery, width, height, angle);
        layers.push(layer);

        if (redraw)
            redrawCanvas();

        return layer;
    }
    this.redraw = function (layer) {
        redrawCanvas(layer);
    }
    this.redrawWhenAllImgLoaded = function () {
        var interval = setInterval(function () {
            for (i in layers) {
                if (layers[i].isVisible() && layers[i].img && !layers[i].imgLoaded)
                    return;
            }
            clearInterval(interval);
            if (layers.length > 1)
                redrawCanvas();
            readyToSaveImg = true;
        }, 100)
    }
    this.getCanvas = function () {
        return canvas;
    }
    this.setBackgroundImage = function (img, redraw) {
        backgroundImage = img;
        if (redraw)
            redrawCanvas();
    }
    this.setBackgroundColor = function (color, redraw) {
        backgroundColor = color;
        if (redraw)
            redrawCanvas();
    }

    // Svg export using canvas2Svg.js
    // Necessite <script src="https://www.shape3d.com/js/canvas2svg.js"></script> https://github.com/gliffy/canvas2svg
    this.getSvg = function () {
        // Context Canvas2Svg pour export SVG
        var contextSvg = new C2S(canvas.width, canvas.height);

        drawCanvas(contextSvg);

        return contextSvg.getSvg(); //inline svg
    }
    this.getSerializedSvg = function () {
        // Context Canvas2Svg pour export SVG
        var contextSvg = new C2S(canvas.width, canvas.height);

        drawCanvas(contextSvg);

        return contextSvg.getSerializedSvg(true); //returns the serialized SVG document. true here will replace any named entities with numbered ones.
    }

    this.addShape = function (newshape, redraw) {
        shapes.push(newshape);

        if (redraw)
            redrawCanvas();

        // Ajout Clem le 09/05/2019
        newshape.draw(context);
    }
    this.getShapes = function () {
        return shapes;
    }
    this.getShape = function (i) {
        return shapes[i];
    }

    this.getLayers = function () {
        return layers;
    }
    this.getLayer = function (i) {
        return layers[i];
    }
    this.getLayerCoordinates = function (i) {
        var info = layers[i].getCoordinates();
        return info;
    }
    this.getLayersCoordinates = function () {
        var infos = "";
        for (i in layers) {
            infos += "{layer" + i.toString() + ":" + this.getLayerCoordinates(i) + "}";
        }
        return infos;
    }
    this.moveLayerUp = function (i) {
        i = parseInt(i);
        if (i < layers.length - 1) {
            var swapLayer = layers[1 + i];
            layers[1 + i] = layers[i];
            layers[i] = swapLayer;
            redrawCanvas();
            return true;
        } else {
            return false;
        }
    }
    this.moveLayerDown = function (i) {
        i = parseInt(i);
        if (i > 0) {
            var swapLayer = layers[i - 1];
            layers[i - 1] = layers[i];
            layers[i] = swapLayer;
            redrawCanvas();
            return true;
        } else {
            return false;
        }
    }
    this.removeLayer = function (i) {
        i = parseInt(i);
        if (i >= 0 && i < layers.length) {
            layers.splice(i, 1);
            redrawCanvas();
        }
    }

    function redrawCanvas(layer) {
        drawCanvas(context, layer);
    }
    function drawCanvas(ctx, layer) {

        if (!layer) {
            if (backgroundImage != null) {
                ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height);
            } else if (backgroundColor != null && backgroundColor != "") {
                ctx.fillStyle = backgroundColor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            } else {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        }

        for (j in shapes) {
            if (!layer)
                shapes[j].draw(ctx);

            for (i in layers) {
                if ((!layer || layers[i] == layer) && layers[i].iShape == j && layers[i].isVisible()) {
                    ctx.save();

                    ctx.globalAlpha = layers[i].getOpacity();
                    ctx.globalCompositeOperation = layers[i].getCompositeOperation();

                    if (layers[i].hasShadow()) {
                        ctx.shadowColor = "#000";
                        ctx.shadowOffsetX = 3;
                        ctx.shadowOffsetY = 3;
                        ctx.shadowBlur = 15;
                    }

                    ctx.translate(layers[i].centerX, layers[i].centerY);
                    ctx.rotate(layers[i].angle);
                    if (ctx.constructor.name == "CanvasRenderingContext2D")
                        ctx.drawImage(layers[i].getCanvas(mouseDown), -(layers[i].width / 2), -(layers[i].height / 2));
                    else { // to Svg
                        layers[i].draw(ctx, false);
                        //if (layers[i].img != null)
                        //    ctx.drawImage(layers[i].img, -(layers[i].width / 2), -(layers[i].height / 2));
                        //else
                        //    ctx.drawImage(layers[i].getCanvas(mouseDown), -(layers[i].width / 2), -(layers[i].height / 2));
                    }

                    ctx.restore();
                }
            }
        }

        for (i in layers) {
            if ((!layer || layers[i] == layer) && layers[i].iShape < 0 && layers[i].isVisible()) {
                ctx.save();

                ctx.globalAlpha = layers[i].getOpacity();
                ctx.globalCompositeOperation = layers[i].getCompositeOperation();

                if (layers[i].hasShadow()) {
                    ctx.shadowColor = "#000";
                    ctx.shadowOffsetX = 3;
                    ctx.shadowOffsetY = 3;
                    ctx.shadowBlur = 15;
                }

                ctx.translate(layers[i].centerX, layers[i].centerY);
                ctx.rotate(layers[i].angle);

                if (ctx.constructor.name == "CanvasRenderingContext2D")
                    ctx.drawImage(layers[i].getCanvas(mouseDown), -(layers[i].width / 2), -(layers[i].height / 2));
                else { // to Svg
                    layers[i].draw(ctx, false);
                    //if (layers[i].img != null)
                    //    ctx.drawImage(layers[i].img, -(layers[i].width / 2), -(layers[i].height / 2));
                    //else
                    //    ctx.drawImage(layers[i].getCanvas(mouseDown), -(layers[i].width / 2), -(layers[i].height / 2));
                }

                ctx.restore();
            }
        }
    }

    function drawMarker(layer) {
        redrawCanvas();

        // Stop clipping test 06/11/2018
        context.restore();
        for (j in shapes) {
            if (shapes[j].clip)
                context.restore();
        }

        context.save();
        context.lineWidth = 1;
        context.strokeStyle = "#fff";
        context.globalAlpha = 0.85;

        context.translate(layer.centerX, layer.centerY);
        context.rotate(layer.angle);

        if (layer.allowDrag || layer.allowResize || layer.allowRotation)
            context.strokeRect(-layer.width / 2, -layer.height / 2, layer.width, layer.height);

        if (layer.allowResize) {
            if (layerState == SCALING) {
                var wh = scaleImg.width * 1.2;
                context.drawImage(scaleImg, (layer.width / 2) - scaleImg.width, (layer.height / 2) - scaleImg.height, wh, wh);
            }
            else
                context.drawImage(scaleImg, (layer.width / 2) - scaleImg.width, (layer.height / 2) - scaleImg.height);
        }

        if (layer.allowRotation) {
            var whmin = Math.min(layer.width, layer.height);
            var whmax = Math.max(layer.width, layer.height) * 0.5;
            var wh = Math.min(whmin, whmax);
            var wh = Math.min(wh, rotateImgLrg.width);
            if (layerState == ROTATING)
                wh = wh * 1.2;
            wh = Math.max(wh, 16);
            context.drawImage(rotateImgLrg, (layer.width / 2) - wh * 0.5, 0 - (layer.height / 2) - wh * 0.5, wh, wh);
        }

        context.restore();
    }

    function mouseMoveEvent(e) {
        var pX = e.pageX;
        var pY = e.pageY;
        if (touch && e.changedTouches) {
            pX = e.changedTouches[0].pageX;
            pY = e.changedTouches[0].pageY;
        }
        var offset = jQuery(canvasId).offset();
        var canvasOffsetX = offset.left;
        var canvasOffsetY = offset.top;
        pX -= canvasOffsetX;
        pY -= canvasOffsetY;

        // Pour test debug
        //if (document.getElementById("eventinput")) {
        //    document.getElementById("eventinput").value = "Move";
        //}

        if (mouseDown && layerState == SCALING) {
            var square = selectedLayer.getSquare();

            var scaleToWidth = selectedLayer.width;
            var scaleToHeight = selectedLayer.height;
            var dOD = Math.pow(square.origin.x - square.d.x, 2) + Math.pow(square.origin.y - square.d.y, 2); // Distance centre coin d
            if (dOD > 0) {
                var dPO = Math.pow(square.origin.x - pX, 2) + Math.pow(square.origin.y - pY, 2); // Distance centre
                var fact = Math.sqrt(dPO / dOD);
                scaleToWidth = scaleToWidth * fact;
                scaleToHeight = scaleToHeight * fact;
            }
            else {
                scaleToWidth = Math.sqrt(Math.pow(square.d.x - pX, 2) + Math.pow(square.d.y - pY, 2)); // Distance au coins D (le grab est au coin C)
                if (selectedLayer.width > 0) // Conserve proportions
                    scaleToHeight = scaleToWidth * (selectedLayer.height / selectedLayer.width);
            }

            selectedLayer.scale(scaleToWidth, scaleToHeight);
            drawMarker(selectedLayer);

            mousePrevX = pX;
            mousePrevY = pY;

            if (selectedLayer.cooTextId != "" && document.getElementById(selectedLayer.cooTextId))
                document.getElementById(selectedLayer.cooTextId).value = selectedLayer.getCoordinates();
            // Ajout Clem le 16/11/2017
            selectedLayer.requireSavingCoordinates = true;
        }
        else if (mouseDown && layerState == ROTATING) {
            var originX = selectedLayer.centerX;
            var originY = selectedLayer.centerY;
            var mouseX = pX;
            var mouseY = pY;

            var dpx = mouseX - mousePrevX;
            var dpy = mouseY - mousePrevY;
            var rx = mouseX - originX;
            var ry = mouseY - originY;
            var r2 = rx * rx + ry * ry;
            var dphortox = dpx * ry;
            var dphortoy = dpy * rx;
            var dphor2 = dphortox * dphortox + dphortoy * dphortoy;
            var tant = Math.sqrt(dphor2) / r2;
            var prodvect = dphortox - dphortoy;
            var angle = selectedLayer.angle;
            if (prodvect > 0)
                angle -= Math.atan(tant);
            else
                angle += Math.atan(tant);
            selectedLayer.angle = angle;

            drawMarker(selectedLayer);

            mousePrevX = pX;
            mousePrevY = pY;

            if (selectedLayer.cooTextId != "" && document.getElementById(selectedLayer.cooTextId))
                document.getElementById(selectedLayer.cooTextId).value = selectedLayer.getCoordinates();
            // Ajout Clem le 16/11/2017
            selectedLayer.requireSavingCoordinates = true;
        }
        else if (mouseDown && layerState == MOVING) {
            if (selectedLayer.maxX > selectedLayer.minX) {
                var dx = 0;
                var newX = selectedLayer.centerX + pX - mousePrevX;
                if (newX < selectedLayer.minX) {
                    dx = selectedLayer.minX - newX;
                    newX = selectedLayer.minX;
                }
                else if (newX > selectedLayer.maxX) {
                    dx = selectedLayer.maxX - newX;
                    newX = selectedLayer.maxX;
                }
                mousePrevX = pX + dx;

                selectedLayer.centerX = newX;
            }
            else {
                selectedLayer.centerX += pX - mousePrevX;
                mousePrevX = pX;
            }
            if (selectedLayer.maxY > selectedLayer.minY) {
                var dy = 0;
                var newY = selectedLayer.centerY + pY - mousePrevY;
                if (newY < selectedLayer.minY) {
                    dy = selectedLayer.minY - newY;
                    newY = selectedLayer.minY;
                }
                else if (newY > selectedLayer.maxY) {
                    dy = selectedLayer.maxY - newY;
                    newY = selectedLayer.maxY;
                }
                mousePrevY = pY + dy;

                selectedLayer.centerY = newY;
            }
            else {
                selectedLayer.centerY += pY - mousePrevY;
                mousePrevY = pY;
            }

            drawMarker(selectedLayer);

            if (selectedLayer.cooTextId != "" && document.getElementById(selectedLayer.cooTextId))
                document.getElementById(selectedLayer.cooTextId).value = selectedLayer.getCoordinates();
            // Ajout Clem le 16/11/2017
            selectedLayer.requireSavingCoordinates = true;
        }
        else if (layers.length > 0) {
            // Ajout Clem le 13/02/2020 pour les déplacements au clavier
            if (typeof (updateOption) == "function" && selectedLayer && selectedLayer.cooTextId != "" && selectedLayer.requireSavingCoordinates) {
                selectedLayer.requireSavingCoordinates = false;
                var optionType = (this.id == "myCanvasOtlSetupGraphics" ? "LogoCoordinates" : "BottomLogoCoordinates"); // l'id du canvas est défini dans CBoardCanvas.cs
                updateOption(optionType, selectedLayer.cooTextId, selectedLayer.getCoordinates());
            }

            var intersected = updateLayerState(pX, pY);
            if (!intersected) {
                layerState = NONE;
                // Ajout Clem le 30/01/2019
                if (selectedLayer != null && typeof (highlightUploadedLogo) == "function")
                    highlightUploadedLogo(-1);
                selectedLayer = null; // TV 16/11/2018

                if (typeof queryString == "undefined" || !queryString["FullScaleDpi"])
                    redrawCanvas();

                document.body.style.cursor = 'default';
            }

            mousePrevX = pX;
            mousePrevY = pY;
        }
    }

    function updateLayerState(pX, pY) {
        var intersected = false;
        if (layers.length > 0) {
            for (var i = layers.length; i--; i >= 0) {
                if (layers[i].isVisible() && (layers[i].allowDrag || layers[i].allowRotation || layers[i].allowResize)) {
                    var rot = false, sca = false;
                    intersected = layers[i].intersect(pX, pY);
                    rot = (layers[i].allowRotation && isRotatingArea(pX, pY, layers[i]));
                    if (!rot)
                        sca = (layers[i].allowResize && isScalingArea(pX, pY, layers[i]));
                    if (!intersected && (rot || sca))
                        intersected = true;
                    if (intersected) {
                        // Ajout Clem le 30/01/2019
                        if (selectedLayer != layers[i] && typeof (highlightUploadedLogo) == "function")
                            highlightUploadedLogo(layers[i].cooTextId);
                        selectedLayer = layers[i];

                        if (rot) {
                            layerState = ROTATING;
                            document.body.style.cursor = 'pointer';
                        }
                        else if (sca) {
                            layerState = SCALING;
                            document.body.style.cursor = 'nw-resize';
                        }
                        else if (layers[i].allowDrag) {
                            layerState = MOVING;
                            document.body.style.cursor = 'move';
                        }
                        else {
                            layerState = NONE;
                            document.body.style.cursor = 'default';
                        }

                        drawMarker(layers[i]);

                        break;
                    }
                }
            }
        }
        return intersected;
    }

    function mouseDownEvent(e) {
        mouseDown = true;
    }

    function mouseUpEvent(e) {
        mouseDown = false;
        layerState = NONE;

        // Ajout Clem le 16/11/2017
        if (typeof (updateOption) == "function" && selectedLayer && selectedLayer.cooTextId != "" && selectedLayer.requireSavingCoordinates) {
            selectedLayer.requireSavingCoordinates = false;
            var optionType = (this.id == "myCanvasOtlSetupGraphics" ? "LogoCoordinates" : "BottomLogoCoordinates"); // l'id du canvas est défini dans CBoardCanvas.cs
            updateOption(optionType, selectedLayer.cooTextId, selectedLayer.getCoordinates());
        }

        selectedLayer = null; // TV 16/11/2018
    }

    function mouseOutEvent(e) {
        mouseUpEvent(e);
    }

    function touchMoveEvent(e) {
        touch = true; // pour event.preventDefault(); pas mettre tout le temps sinon ne fonctionne plus avec IE 10

        // Prevents the original event handler behaciour
        if (layerState == SCALING || layerState == ROTATING || layerState == MOVING) {
            e.stopPropagation(); // Test 08/12/2014 pour Windows 8 tactil
            //event.preventDefault(); // 08/12/2013 pour touch screen
            e.preventDefault(); // 08/12/2013 pour touch screen
        }
        
        mouseMoveEvent(e);
    }
    function touchStartEvent(e) {
        touch = true; // pour event.preventDefault(); pas mettre tout le temps sinon ne fonctionne plus avec IE 10
        
        var pX = e.pageX;
        var pY = e.pageY;
        if (touch && e.changedTouches) {
            pX = e.changedTouches[0].pageX;
            pY = e.changedTouches[0].pageY;
        }
        var offset = jQuery(canvasId).offset();
        var canvasOffsetX = offset.left;
        var canvasOffsetY = offset.top;
        pX -= canvasOffsetX;
        pY -= canvasOffsetY;
        if (updateLayerState(pX, pY))
        {
            mousePrevX = pX;
            mousePrevY = pY;
        }

        // Prevents the original event handler behaciour
        if (layerState == SCALING || layerState == ROTATING || layerState == MOVING) {
            e.stopPropagation(); // Test 08/12/2014 pour Windows 8 tactil
            //event.preventDefault(); // 08/12/2013 pour touch screen
            e.preventDefault(); // 08/12/2013 pour touch screen
        }

        mouseDownEvent(e)
    }
    function touchEndEvent(e) {
        touch = false;
        mouseUpEvent(e)
    }

    function isScalingArea(mX, mY, layer) {
        var w;
        var h;
        if (layer.width > 100 && layer.height > 100) {
            w = Math.min(layer.width, layer.height) * 0.35;
            w = Math.min(w, 40);
            h = w;
        }
        else {
            var whmin = Math.min(layer.width, layer.height);
            var whmax = Math.max(layer.width, layer.height) * 0.5;
            w = Math.min(whmin, whmax);
            if (touch)
                w = Math.max(w, 30);
            else
                w = Math.max(w, 16);
            h = w;
        }
        var square = new Square(
            new Vector(-w, 0),
        new Vector(0, 0),
        new Vector(0, h),
        new Vector(-w, h));

        square.rotate(layer.angle);

        if (w <= layer.width * 0.5 || h <= layer.height * 0.5)
            square.alignCenter(layer.getSquare().c);
        else {
            var mido = new Vector((layer.getSquare().c.x + layer.getSquare().origin.x) * 0.5, (layer.getSquare().c.y + layer.getSquare().origin.y) * 0.5); // entre origin et c
            square.alignTopLeft(mido);
        }

        return square.intersect(new Vector(mX, mY));
    }

    function isRotatingArea(mX, mY, layer) {

        var w;
        var h;
        if (layer.width > 100 && layer.height > 100) {
            w = Math.min(layer.width, layer.height) * 0.35;
            w = Math.min(w, 40);
            h = w;
        }
        else  {
            var whmin = Math.min(layer.width, layer.height);
            var whmax = Math.max(layer.width, layer.height) * 0.5;
            w = Math.min(whmin, whmax);
            if (touch)
                w = Math.max(w, 30);
            else
                w = Math.max(w, 16);
            h = w;
        }
        
        var square = new Square(
            new Vector(-w, 0),
        new Vector(0, 0),
        new Vector(0, h),
        new Vector(-w, h));

        square.rotate(layer.angle);
        
        if (w <= layer.width * 0.5 || h <= layer.height * 0.5)
            square.alignCenter(layer.getSquare().b);
        else {
            var mido = new Vector((layer.getSquare().b.x + layer.getSquare().origin.x) * 0.5, (layer.getSquare().b.y + layer.getSquare().origin.y) * 0.5); // entre origin et b
            square.alignBottomLeft(mido);
        }

        return square.intersect(new Vector(mX, mY));
    }

    this.isReadyToSaveImg = function () {
        return readyToSaveImg;
    }
    this.toDataURL = function () {
        // save canvas image as data url (png format by default)
        var dataURL = canvas.toDataURL("image/png"); // The toDataURL() method requires that any images drawn onto the canvas are hosted on a web server with the same domain as the code executing it.  If this condition is not met, a SECURITY_ERR exception is thrown.
        return dataURL;
    }
    this.toDataURLJPEG = function () {
        // save canvas image as data url in jpeg
        var dataURL = canvas.toDataURL("image/jpeg"); // The toDataURL() method requires that any images drawn onto the canvas are hosted on a web server with the same domain as the code executing it.  If this condition is not met, a SECURITY_ERR exception is thrown.
        return dataURL;
    }
    // Ajout Clem le 13/02/2020
    this.keyDownEvent = function (e) {
        if (selectedLayer) {
            if (e.key == "ArrowUp" || e.key == "ArrowRight" || e.key == "ArrowDown" || e.key == "ArrowLeft") {
                var step = 1;
                if (e.shiftKey && e.ctrlKey)
                    step = 10;
                else if (e.ctrlKey)
                    step = 4;
                else if (e.shiftKey)
                    step = 2;
                if (e.key == "ArrowUp")
                    selectedLayer.centerY -= step;
                else if (e.key == "ArrowDown")
                    selectedLayer.centerY += step;
                else if (e.key == "ArrowLeft")
                    selectedLayer.centerX -= step;
                else if (e.key == "ArrowRight")
                    selectedLayer.centerX += step;
                drawMarker(selectedLayer);

                if (selectedLayer.cooTextId != "" && document.getElementById(selectedLayer.cooTextId))
                    document.getElementById(selectedLayer.cooTextId).value = selectedLayer.getCoordinates();
                // Ajout Clem le 16/11/2017
                selectedLayer.requireSavingCoordinates = true;

                e.preventDefault(); // prevent the default action (scroll / move caret)
            }
        }
    }
}

function Square(a, b, c, d) {
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
    this.origin = centerSquareOrigin(a, b, c, d);

    this.intersect = function (mouse) {
        return (!intersectWithLine(this.origin, mouse, this.a, this.b) &&
    !intersectWithLine(this.origin, mouse, this.b, this.c) &&
    !intersectWithLine(this.origin, mouse, this.c, this.d) &&
    !intersectWithLine(this.origin, mouse, this.d, this.a));
    }

    this.rotate = function (angle) {
        var radius = Math.sqrt(Math.pow(this.origin.x - this.a.x, 2) + Math.pow(this.origin.y - this.a.y, 2));

        var aAngle = Math.atan2((this.a.y - this.origin.y), (this.a.x - this.origin.x));
        var bAngle = Math.atan2((this.b.y - this.origin.y), (this.b.x - this.origin.x));
        var cAngle = Math.atan2((this.c.y - this.origin.y), (this.c.x - this.origin.x));
        var dAngle = Math.atan2((this.d.y - this.origin.y), (this.d.x - this.origin.x));

        this.a.x = this.origin.x + radius * Math.cos(angle + aAngle);
        this.a.y = this.origin.y + radius * Math.sin(angle + aAngle);
        this.b.x = this.origin.x + radius * Math.cos(angle + bAngle);
        this.b.y = this.origin.y + radius * Math.sin(angle + bAngle);
        this.c.x = this.origin.x + radius * Math.cos(angle + cAngle);
        this.c.y = this.origin.y + radius * Math.sin(angle + cAngle);
        this.d.x = this.origin.x + radius * Math.cos(angle + dAngle);
        this.d.y = this.origin.y + radius * Math.sin(angle + dAngle);
    }

    this.alignBottomRight = function (alignPoint) {
        var diff = new Vector(alignPoint.x - this.c.x, alignPoint.y - this.c.y);

        this.a = this.a.add(diff);
        this.b = this.b.add(diff);
        this.c = this.c.add(diff);
        this.d = this.d.add(diff);
        this.origin = centerSquareOrigin(this.a, this.b, this.c, this.d);
    }
    this.alignTopRight = function (alignPoint) {
        var diff = new Vector(alignPoint.x - this.b.x, alignPoint.y - this.b.y);

        this.a = this.a.add(diff);
        this.b = this.b.add(diff);
        this.c = this.c.add(diff);
        this.d = this.d.add(diff);
        this.origin = centerSquareOrigin(this.a, this.b, this.c, this.d);
    }
    this.alignBottomLeft = function (alignPoint) {
        var diff = new Vector(alignPoint.x - this.d.x, alignPoint.y - this.d.y);

        this.a = this.a.add(diff);
        this.b = this.b.add(diff);
        this.c = this.c.add(diff);
        this.d = this.d.add(diff);
        this.origin = centerSquareOrigin(this.a, this.b, this.c, this.d);
    }
    this.alignTopLeft = function (alignPoint) {
        var diff = new Vector(alignPoint.x - this.a.x, alignPoint.y - this.a.y);

        this.a = this.a.add(diff);
        this.b = this.b.add(diff);
        this.c = this.c.add(diff);
        this.d = this.d.add(diff);
        this.origin = centerSquareOrigin(this.a, this.b, this.c, this.d);
    }

    this.alignCenter = function (alignPoint) {
        var diff = new Vector(alignPoint.x - this.origin.x, alignPoint.y - this.origin.y);

        this.a = this.a.add(diff);
        this.b = this.b.add(diff);
        this.c = this.c.add(diff);
        this.d = this.d.add(diff);
        this.origin = centerSquareOrigin(this.a, this.b, this.c, this.d);
    }

    var epsilon = 1.0e-6;

    function centerSquareOrigin(a, b, c, d) {
        var p = a;
        var r = c.subtract(a);
        var q = b;
        var s = d.subtract(b);

        var rCrossS = r.cross(s); //cross(r, s);
        if (rCrossS <= epsilon && rCrossS >= -1 * epsilon) {
            return;
        }

        q = q.subtract(p);
        var t = q.cross(s) / rCrossS; //cross(q.subtract(p), s) / rCrossS;
        var u = q.cross(r) / rCrossS; //cross(q.subtract(p), r) / rCrossS;
        if (0 <= u && u <= 1 && 0 <= t && t <= 1) {
            var intPoint = p.add(r.scalarMult(t));
            return new Vector(intPoint.x, intPoint.y);
        }

        return null;
    }

    function intersectWithLine(l1p1, l1p2, l2p1, l2p2) {
        var p = l1p1;
        var r = l1p2.subtract(l1p1);
        var q = l2p1;
        var s = l2p2.subtract(l2p1);

        var rCrossS = r.cross(s); //cross(r, s);
        if (rCrossS <= epsilon && rCrossS >= -1 * epsilon) {
            return false;
        }

        q = q.subtract(p);
        var t = q.cross(s) / rCrossS; //cross(q.subtract(p), s) / rCrossS;
        var u = q.cross(r) / rCrossS; //cross(q.subtract(p), r) / rCrossS;
        if (0 <= u && u <= 1 && 0 <= t && t <= 1) {
            return true;
        } else {
            return false;
        }
    }
}

/**
* http://bloggingmath.wordpress.com/2009/05/29/line-segment-intersection/
*/
function Vector(x, y) {
    this.x = x;
    this.y = y;

    this.copy = function (v) {
        this.x = v.x;
        this.y = v.y;
    }
    this.scalarMult = function (scalar) {
        return new Vector(this.x * scalar, this.y * scalar);
    }
    this.dot = function (v2) {
        return this.x * v2.x + this.y * v2.y;
    };
    this.cross = function (v2) {
        return this.x * v2.y - this.y * v2.x;
    };
    this.perp = function () {
        return new Vector(-1 * this.y, this.x);
    };
    this.subtract = function (v2) {
        return this.add(v2.scalarMult(-1)); //new Vector(this.x - v2.x, this.y - v2.y);
    };
    this.add = function (v2) {
        return new Vector(this.x + v2.x, this.y + v2.y);
    }
}

function Segment(p0, p1) { // P0 et P1 sont des Vector
    this.p0 = new Vector(p0.x, p0.y);
    this.p1 = new Vector(p1.x, p1.y);
    this.v = this.p1.subtract(this.p0);
    this.d2 = this.v.dot(this.v);

    var epsilon = 1.0e-2;

    this.calculeVect = function () {
        this.v = this.p1.subtract(this.p0);
        this.d2 = this.v.dot(this.v);
    }
    this.setp0 = function (p0) {
        this.p0.copy(p0);
        this.calculeVect();
    }
    this.setp1 = function (p1) {
        this.p1.copy(p1);
        this.calculeVect();
    }
    this.copy = function (s) {
        this.p0.copy(s.p0);
        this.p1.copy(s.p1);
        this.v.copy(s.v);
        this.d2 = s.d2;
    }
    this.decalleVect = function (dec)
    { // p0 et p1 sont des Vector
        if (this.d2 > epsilon) {
            var d = Math.sqrt(this.d2);
            var nx = (-this.v.y / d) * dec;
            var ny = (this.v.x / d) * dec;

            this.p0.x += nx;
            this.p0.y += ny;
            this.p1.x += nx;
            this.p1.y += ny;

            return true;
        }
        else
            return false;
    }
    this.intersection = function (seg, pi) { // seg est un autre segment
        if (this.d2 > epsilon && seg.d2 > epsilon) {
            var delta = this.v.cross(seg.v);

            if (Math.abs(delta) < 1.0e-6) // paralleles
            {
                pi.x = this.p1.x;
                pi.y = this.p1.y;
                return true;
            }
            else {
                var a = this.v.cross(this.p1);
                var da = seg.p1.cross(seg.v);
                pi.x = (this.v.x * da + seg.v.x * a) / delta;
                pi.y = (this.v.y * da + seg.v.y * a) / delta;

                return true;
            }
        }
        else {
            pi.x = pi.y = 0;
            return false;
        }
    }
    this.lambda = function (p) {
        if (this.d2 > epsilon) {
            var dp = p.subtract(this.p0);

            return dp.dot(this.v) / this.d2;
        }
        else
            return 0;
    }
    this.f_de_x = function (x) {
        if (Math.abs(this.v.x) > epsilon) {
            var y = (x * this.v.y - this.p0.cross(this.p1)) / this.v.x;
            return new Vector(x, y);
        }
        else {
            if (x != this.p0.x) {
                return new Vector(0, 0);
            }
            else {    // Cas indéterminé
                return this.p0; // n'importe quel point
            }
        }
        return true;
    }
}

// http://jsfiddle.net/9g9Nv/96/ http://stackoverflow.com/questions/18922880/html5-canvas-resize-downscale-image-high-quality
function resample_hermite(canvas, W, H, W2, H2) {
    var time1 = Date.now();
    W2 = Math.round(W2);
    H2 = Math.round(H2);
    var img = canvas.getContext("2d").getImageData(0, 0, W, H);
    var img2 = canvas.getContext("2d").getImageData(0, 0, W2, H2);
    var data = img.data;
    var data2 = img2.data;
    var ratio_w = W / W2;
    var ratio_h = H / H2;
    var ratio_w_half = Math.ceil(ratio_w / 2);
    var ratio_h_half = Math.ceil(ratio_h / 2);

    for (var j = 0; j < H2; j++) {
        for (var i = 0; i < W2; i++) {
            var x2 = (i + j * W2) * 4;
            var weight = 0;
            var weights = 0;
            var weights_alpha = 0;
            var gx_r = gx_g = gx_b = gx_a = 0;
            var center_y = (j + 0.5) * ratio_h;
            for (var yy = Math.floor(j * ratio_h) ; yy < (j + 1) * ratio_h; yy++) {
                var dy = Math.abs(center_y - (yy + 0.5)) / ratio_h_half;
                var center_x = (i + 0.5) * ratio_w;
                var w0 = dy * dy //pre-calc part of w
                for (var xx = Math.floor(i * ratio_w) ; xx < (i + 1) * ratio_w; xx++) {
                    var dx = Math.abs(center_x - (xx + 0.5)) / ratio_w_half;
                    var w = Math.sqrt(w0 + dx * dx);
                    if (w >= -1 && w <= 1) {
                        //hermite filter
                        weight = 2 * w * w * w - 3 * w * w + 1;
                        if (weight > 0) {
                            dx = 4 * (xx + yy * W);
                            //alpha
                            gx_a += weight * data[dx + 3];
                            weights_alpha += weight;
                            //colors
                            if (data[dx + 3] < 255)
                                weight = weight * data[dx + 3] / 250;
                            gx_r += weight * data[dx];
                            gx_g += weight * data[dx + 1];
                            gx_b += weight * data[dx + 2];
                            weights += weight;
                        }
                    }
                }
            }
            data2[x2] = gx_r / weights;
            data2[x2 + 1] = gx_g / weights;
            data2[x2 + 2] = gx_b / weights;
            data2[x2 + 3] = gx_a / weights_alpha;
        }
    }
    //console.log("hermite = " + (Math.round(Date.now() - time1) / 1000) + " s");
    canvas.getContext("2d").clearRect(0, 0, Math.max(W, W2), Math.max(H, H2));
    canvas.width = W2;
    canvas.height = H2;
    canvas.getContext("2d").putImageData(img2, 0, 0);
}

function resample_hermite2(context, srcCanvas, width, height) { // Code obtenu à partir de resample_hermite
    width = Math.round(width);
    height = Math.round(height);
    var srcContext = srcCanvas.getContext("2d");
    var img = srcContext.getImageData(0, 0, srcCanvas.width, srcCanvas.height);
    var img2 = context.createImageData(width, height);
    var data = img.data;
    var data2 = img2.data;
    var ratio_w = srcCanvas.width / width;
    var ratio_h = srcCanvas.height / height;
    var ratio_w_half = Math.ceil(ratio_w / 2);
    var ratio_h_half = Math.ceil(ratio_h / 2);

    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var x2 = (i + j * width) * 4;
            var weight = 0;
            var weights = 0;
            var weights_alpha = 0;
            var gx_r = gx_g = gx_b = gx_a = 0;
            var center_y = (j + 0.5) * ratio_h;
            for (var yy = Math.floor(j * ratio_h); yy < (j + 1) * ratio_h; yy++) {
                var dy = Math.abs(center_y - (yy + 0.5)) / ratio_h_half;
                var center_x = (i + 0.5) * ratio_w;
                var w0 = dy * dy //pre-calc part of w
                for (var xx = Math.floor(i * ratio_w); xx < (i + 1) * ratio_w; xx++) {
                    var dx = Math.abs(center_x - (xx + 0.5)) / ratio_w_half;
                    var w = Math.sqrt(w0 + dx * dx);
                    if (w >= -1 && w <= 1) {
                        //hermite filter
                        weight = 2 * w * w * w - 3 * w * w + 1;
                        if (weight > 0) {
                            dx = 4 * (xx + yy * srcCanvas.width);
                            //alpha
                            gx_a += weight * data[dx + 3];
                            weights_alpha += weight;
                            //colors
                            if (data[dx + 3] < 255)
                                weight = weight * data[dx + 3] / 250;
                            gx_r += weight * data[dx];
                            gx_g += weight * data[dx + 1];
                            gx_b += weight * data[dx + 2];
                            weights += weight;
                        }
                    }
                }
            }
            data2[x2] = gx_r / weights;
            data2[x2 + 1] = gx_g / weights;
            data2[x2 + 2] = gx_b / weights;
            data2[x2 + 3] = gx_a / weights_alpha;
        }
    }
    context.putImageData(img2, 0, 0);
}
function resample_hermite3(context, srcCanvas, width, height) { // Code obtenu en mélangeant https://github.com/viliusle/Hermite-resize et resample_hermite2, plus rapide que resample_hermite2 mais pas compris pourquoi
    var width_source = srcCanvas.width;
    var height_source = srcCanvas.height;
    width = Math.round(width);
    height = Math.round(height);

    var ratio_w = width_source / width;
    var ratio_h = height_source / height;
    var ratio_w_half = Math.ceil(ratio_w / 2);
    var ratio_h_half = Math.ceil(ratio_h / 2);

    var temp_ctx = srcCanvas.getContext("2d");
    var data = temp_ctx.getImageData(0, 0, width_source, height_source).data;
    var img2 = temp_ctx.createImageData(width, height);
    var data2 = img2.data;

    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var x2 = (i + j * width) * 4;
            var weight = 0;
            var weights = 0;
            var weights_alpha = 0;
            var gx_r = 0;
            var gx_g = 0;
            var gx_b = 0;
            var gx_a = 0;
            //var center_y = j * ratio_h;
            var center_y = (j + 0.5) * ratio_h;

            var xx_start = Math.floor(i * ratio_w);
            //var xx_stop = Math.ceil((i + 1) * ratio_w);
            var xx_stop = (i + 1) * ratio_w;
            var yy_start = Math.floor(j * ratio_h);
            //var yy_stop = Math.ceil((j + 1) * ratio_h);
            var yy_stop = (j + 1) * ratio_h;
            xx_stop = Math.min(xx_stop, width_source);
            yy_stop = Math.min(yy_stop, height_source);

            for (var yy = yy_start; yy < yy_stop; yy++) {
                //var dy = Math.abs(center_y - yy) / ratio_h_half;
                var dy = Math.abs(center_y - yy - 0.5) / ratio_h_half;
                //var center_x = i * ratio_w;
                var center_x = (i + 0.5) * ratio_w;
                var w0 = dy * dy; //pre-calc part of w
                for (var xx = xx_start; xx < xx_stop; xx++) {
                    //var dx = Math.abs(center_x - xx) / ratio_w_half;
                    var dx = Math.abs(center_x - xx - 0.5) / ratio_w_half;
                    var w = Math.sqrt(w0 + dx * dx);
                    if (w >= 1)
                        //pixel too far
                        continue;
                    //hermite filter
                    weight = 2 * w * w * w - 3 * w * w + 1;
                    var pos_x = 4 * (xx + yy * width_source);
                    //alpha
                    gx_a += weight * data[pos_x + 3];
                    weights_alpha += weight;
                    //colors
                    if (data[pos_x + 3] < 255)
                        weight = weight * data[pos_x + 3] / 250;
                    gx_r += weight * data[pos_x];
                    gx_g += weight * data[pos_x + 1];
                    gx_b += weight * data[pos_x + 2];
                    weights += weight;
                }
            }
            data2[x2] = gx_r / weights;
            data2[x2 + 1] = gx_g / weights;
            data2[x2 + 2] = gx_b / weights;
            data2[x2 + 3] = gx_a / weights_alpha;
        }
    }

    //draw
    context.putImageData(img2, 0, 0);
};